<h2 class="cell shrink mailBox-title"[i18nKey]="'mail.box.new.message.title'"></h2>

<div class="cell shrink grid-x">
    <span class="cell shrink mailBox-heading"[i18nKey]="'mail.box.new.message.recipients'"></span>
    <div *ngIf="recipients" class="cell auto grid-x mailBox-recipientsList">
        <span *ngIf="recipients.length < 1; else recipientsList"[i18nKey]="'mail.box.new.message.recipients.none'"></span>
        <ng-template #recipientsList>
            <ng-container *ngFor="let usersList of recipients">
                <chip (click)="onUsersListDeleted(usersList)"
                      [label]="usersList.name" class="cell shrink"></chip>
            </ng-container>
        </ng-template>
    </div>
</div>

<div class="cell shrink">
    <hr class="mailBox-separator">
</div>

<div class="cell shrink grid-x align-middle">
    <span class="cell shrink mailBox-heading"[i18nKey]="'mail.box.new.message.subject'"></span>
    <label class="cell auto">
        <input [(ngModel)]="message.subject" class="mailBox-objectInput" type="text">
    </label>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<label class="cell auto grid-y">
    <kiwi-textarea class="mailBox-messageArea"
        [(ngModel)]="message.content">
    </kiwi-textarea>
</label>

<kiwi-spacer [size]="8"></kiwi-spacer>

<div class="cell shrink grid-x align-right">
    <button (click)="sendMessage()"
            [disabled]="message.subject === '' || message.content === '' || recipients.length < 1"
            class="cell shrink button" [i18nKey]="'mail.box.new.message.send'"
            captureId="send-message"></button>
</div>

